import React from 'react';
import Translated from '../Translated';
import { StyledError } from './Field.styled';

const ErrorTag = ({ id, params }) => (<StyledError><Translated id={id} params={params} /></StyledError>);

export default ErrorTag;
